import { WithDeleted } from '@common/typescript/objects/WithDeleted';
import { List } from '@common/typescript/objects/List';
import { IPublished } from '@common/typescript/objects/IPublished';

import { Ethnicity } from '@app/objects/Ethnicity';
import { CasePage } from '@app/objects/CasePage';
import { CaseImage } from '@app/objects/CaseImage';
import { DoctorCase } from '@app/objects/DoctorCase';

export enum Gender {
	Male = 0,
	Female = 1,
	Other = 2,
	None = 3
}

export enum CaseType {
	BreastAugmentation = 0,
	Other = 1
}

export const CaseTypeNames = {
	[CaseType.BreastAugmentation]: 'Breast Augmentation',
	[CaseType.Other]: 'Other',
};

export interface Case extends WithDeleted, IPublished {
	nameEn: string;
	nameEs: string;
	descriptionEn: string;
	descriptionEs: string;
	age: number;
	weight: number;
	height: number;
	gender: Gender;
	ethnicity?: Ethnicity;
	ethnicityId: number | null;
	files: List<CaseImage>;
	pages: Array<CasePage>;
	doctors: Array<DoctorCase>;
	before: string;
	after: string;
	preBra: string;
	postBra: string;
	leftImplant: string;
	rightImplant: string;
	rate: number;
	caseType: CaseType;
	indexInCompany: number;
}
